<template>
  <div>
    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.show"
      width="800px"
      center
    >
      <el-form :inline="true" label-width="100px">
        <el-form-item :label="$t('language')" prop="Lang">
          <el-radio-group v-model="mRadio" @change="OnHandleRadioChange">
            <div
              v-for="item in mLangOptions"
              :key="item"
              style="position: relative; display: inline-block; margin: 4px"
            >
              <el-radio-button :label="item">
                {{ langmap[item] }}<span v-if="item == mEnLangId">({{$t('RequiredField')}})</span>
              </el-radio-button>
              <el-badge
                v-if="OnIsShowRedDot(item)"
                is-dot
                class="red-dot"
              ></el-badge>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('content')+':'">
          <quill-editor
            v-model="textForm.H5KefuPopText"
            ref="myQuillEditor"
            :options="editorOption"
            style="white-space: pre-wrap; width: 600px; margin-top: -30px"
          >
          </quill-editor>
        </el-form-item>
        <el-form-item :label="$t('RedirectLink')+': '">
          <el-input
            v-model="textForm.H5KefuLink"
            style="width: 600px"
          ></el-input>
        </el-form-item>
        <el-form-item label="" v-if="mCanSyncEn && mRadio == mEnLangId">
          <div class="red-box">
            <el-button type="primary" @click="OnClickEnSync"
              >{{$t('SyncConfigToAllLanguages')}}</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="OnClickSure"
          >{{$t('Confirm')}}</el-button
        >
        <el-button size="medium" @click="dialogData.show = false"
          >{{$t('Cancel')}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { app } from "@/api/app.js";
import base from "@/api/base.js";
export default {
  extends: base,
  components: { quillEditor },
  props: {
    dialogData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 编辑器配置
      editorOption: {
        placeholder: "在这里输入内容",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], //  加粗、倾斜、下划线、删除线
            ["blockquote", "code-block"], // 引用代码块
            [{ header: 1 }, { header: 2 }], // 标题，键值对应的形式，1，2 表示字体大小
            [{ list: "ordered" }, { list: "bullet" }], // 列表
            [{ script: "sub" }, { script: "super" }], // 上下标
            [{ indent: -1 }, { indent: +1 }], // 缩进
            [{ direction: "rtl" }], // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
            [{ font: [] }], // 字体
            [{ align: [] }], // 对齐方式
            ["clean"], //清除
            // ['image', 'video'], // 上传图片、上传视频
          ],
        },
      },
      mRadio: 2,
      mEnLangId: 2,
      mLangOptions: [],
      mLangs: {},
      textForm: {
        H5KefuPopText: "",
        H5KefuLink: "",
      },
      mCanSyncEn: false,
    };
  },
  created() {
    this.mCanSyncEn = true;
    this.mLangOptions = [];
    this.mLangOptions.push(this.mEnLangId);
    this.langs.forEach((elem) => {
      if (elem.id != this.mEnLangId) {
        this.mLangOptions.push(elem.id);
      }
    });
    if (this.OnIsJsonString(this.dialogData.row.H5KefuPopText)) {
      const obj = JSON.parse(this.dialogData.row.H5KefuPopText);
      for (const nLangId in obj) {
        if (!this.mLangs[nLangId]) {
          this.mLangs[nLangId] = {};
        }
        this.mLangs[nLangId].H5KefuPopText = obj[nLangId];
      }
      this.textForm.H5KefuPopText = obj[this.mEnLangId];
    } else {
      this.textForm.H5KefuPopText = this.dialogData.row.H5KefuPopText;
    }
    if (this.OnIsJsonString(this.dialogData.row.H5KefuLink)) {
      const obj = JSON.parse(this.dialogData.row.H5KefuLink);
      for (const nLangId in obj) {
        if (!this.mLangs[nLangId]) {
          this.mLangs[nLangId] = {};
        }
        this.mLangs[nLangId].H5KefuLink = obj[nLangId];
      }
      this.textForm.H5KefuLink = obj[this.mEnLangId];
    } else {
      this.textForm.H5KefuLink = this.dialogData.row.H5KefuLink;
    }
    this.OnHandleRadioChange(this.mRadio);
  },
  methods: {
    OnClickEnSync() {
      this.mCanSyncEn = false;
      let tLangs = this.mLangs;
      this.mLangOptions.forEach((elem) => {
        tLangs[elem] = app.clone(tLangs[this.mEnLangId]);
      });
    },
    OnIsJsonString(pStr) {
      try {
        const obj = JSON.parse(pStr);
        // 检查是否为对象或数组
        if (typeof obj === "object" && obj !== null) {
          return true;
        }
      } catch (e) {
        return false;
      }
      return false;
    },
    OnClickEnSync() {
      this.mCanSyncEn = false;
      let tLangs = this.OnGetLangs();
      this.mLangOptions.forEach((elem) => {
        tLangs[elem] = app.clone(tLangs[this.mEnLangId]);
      });
    },
    OnGetLangs() {
      return this.mLangs;
    },
    OnIsShowRedDot(pLang) {
      let tLangs = this.OnGetLangs();
      if (tLangs[pLang] && tLangs[pLang].H5KefuPopText) return true;
      return false;
    },
    OnHandleRadioChange(pValue) {
      let tLangs = this.OnGetLangs();
      if (!tLangs[pValue]) {
        tLangs[pValue] = {
          H5KefuPopText: this.textForm.H5KefuPopText,
          H5KefuLink: this.textForm.H5KefuLink,
        };
      }
      this.textForm = tLangs[pValue];
    },
    OnClickSure() {
      for (const nLangId in this.mLangs) {
        let tItem = this.mLangs[nLangId];
        tItem.H5KefuLink = tItem.H5KefuLink || "";
        if (tItem.H5KefuLink.startsWith("@")) {
          tItem.H5KefuLink = tItem.H5KefuLink.replace("@", "https://t.me/");
        }
        if (!this.OnCheckURL(tItem.H5KefuLink, nLangId)) {
          return;
        }
      }
      let tText = {};
      let tLink = {};
      for (const nLangId in this.mLangs) {
        tText[nLangId] = this.mLangs[nLangId].H5KefuPopText;
        tLink[nLangId] = this.mLangs[nLangId].H5KefuLink;
      }
      this.dialogData.row.H5KefuPopText = JSON.stringify(tText);
      this.dialogData.row.H5KefuLink = JSON.stringify(tLink);
      this.dialogData.show = false;
    },
    OnCheckURL(pUrl, pLangId) {
      let strLangName = this.langmap[pLangId] || "";
      if (!pUrl) {
        this.$message.warning(strLangName + "链接类型的链接地址不能为空");
        return false;
      }
      if (!/^(http|https):\/\/(\S+)$/.test(pUrl)) {
        this.$message.warning(
          strLangName + "链接类型的链接地址需要是http://或https://开头"
        );
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
::v-deep .el-switch__label.is-active {
  color: red;
}

::v-deep .el-switch__label {
  color: #409eff;
}
.red-box {
  border: 2px solid red; /* 红色实线框 */
  width: 750px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  padding: 10px 0px;
}
.red-dot {
  position: absolute;
  top: -1px;
  right: -1px;
}
</style>
